module.exports = "pegasus/assets/circleline-youtube.gif";